var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("normalDialog", {
    attrs: {
      title:
        _vm.$t("label_essweb_StaffCard_list_dialog_cardConfigTitle") +
        "-" +
        _vm.$getCommonLangValue(_vm.curName),
      dialog: _vm.show,
      width: "700",
    },
    on: { close: _vm.closeDialog },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            !_vm.isLoading && _vm.triger === "edit"
              ? _c(
                  "v-container",
                  { staticClass: "d-flex pb-8" },
                  [
                    _c("v-spacer"),
                    _c(
                      "v-btn",
                      {
                        staticClass: "text-capitalize",
                        attrs: { text: "", small: "", color: "primary" },
                        on: { click: _vm.addCard },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "label_essweb_StaffCard_dialog_addCardBtnLabel"
                              )
                            ) +
                            " "
                        ),
                        _c("span", { staticClass: "material-icons-round" }, [
                          _vm._v("add"),
                        ]),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.Data.length == 0 ? _c("noContent") : _vm._e(),
            _c(
              "v-form",
              { ref: "form", attrs: { "lazy-validation": "" } },
              [
                _vm._l(_vm.Data, function (item, index) {
                  return [
                    _c(
                      "v-row",
                      { key: "config--" + index, staticClass: "pa-0 ma-0" },
                      [
                        _c(
                          "v-col",
                          {
                            staticClass: "py-0",
                            attrs: { md: _vm.triger === "edit" ? 5 : 6 },
                          },
                          [
                            _c(
                              "v-sheet",
                              {
                                staticClass: "mrc_text_require text--secondary",
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "label_essweb_StaffCard_dialog_cardCodeLabel"
                                    )
                                  )
                                ),
                              ]
                            ),
                            _c("v-text-field", {
                              attrs: {
                                "single-line": "",
                                maxlength: "50",
                                readonly: _vm.triger === "view",
                                filled: _vm.triger === "edit",
                                disabled:
                                  _vm.triger === "edit" &&
                                  _vm.timeCompare(
                                    item.effective_utc_start_date_save
                                  ),
                                type: "string",
                                rules: _vm.$GetRules(
                                  ["_Require_Rules"],
                                  [null]
                                ),
                                placeholder: _vm.$t(
                                  "label_essweb_StaffCard_dialog_cardCodeLabel"
                                ),
                                dense: "",
                              },
                              model: {
                                value: item.staff_card_code,
                                callback: function ($$v) {
                                  _vm.$set(item, "staff_card_code", $$v)
                                },
                                expression: "item.staff_card_code",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          {
                            staticClass: "py-0",
                            attrs: { md: _vm.triger === "edit" ? 5 : 6 },
                          },
                          [
                            _c("DateTimePicker", {
                              attrs: {
                                type: "date",
                                disabled:
                                  _vm.triger === "edit" &&
                                  _vm.timeCompare(
                                    item.effective_utc_start_date_save
                                  ),
                                readonly: _vm.triger === "view",
                                filled: _vm.triger === "edit",
                                rules: _vm.$GetRules(
                                  ["_Require_Rules"],
                                  [null]
                                ),
                                defaultTime: item.effective_utc_start_date,
                                label: _vm.$t(
                                  "label_essweb_StaffCard_dialog_startDateLabel"
                                ),
                                placeholder: "YYYY/MM/DD",
                                refuseDate: _vm.refuseDate,
                              },
                              on: {
                                change: function (time) {
                                  return (item.effective_utc_start_date = time)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _vm.triger === "edit"
                          ? _c(
                              "v-col",
                              {
                                staticClass: "d-flex align-center pt-0 pb-0 ",
                                attrs: { md: _vm.triger === "edit" ? 1 : 0 },
                              },
                              [
                                !(
                                  item.uuid &&
                                  _vm.timeCompare(
                                    item.effective_utc_start_date_save
                                  )
                                )
                                  ? _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          icon: "",
                                          disabled:
                                            item.uuid &&
                                            _vm.timeCompare(
                                              item.effective_utc_start_date_save
                                            ),
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onDelete(item)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "material-icons-round",
                                          },
                                          [_vm._v("delete")]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                }),
              ],
              2
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _vm.triger === "edit"
              ? _c("CardActions", {
                  attrs: { saveBtn: "" },
                  on: { save: _vm.toSave, cancel: _vm.closeDialog },
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }